var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card-text", { staticClass: "black--text" }, [
    _c("h1", { staticClass: "mb-3" }, [
      _vm._v("Więcej informacji o plikach cookie")
    ]),
    _c("h3", [_vm._v("Co to jest ciasteczko?")]),
    _c("p", [
      _vm._v(
        "Jako ciasteczka, ewent. cookie, w HTTP nazywany jest plikiem tekstowym - niewielką ilością danych, które serwery wysyłają do przeglądarki. Zapisuje je na komputerze użytkownika. Za każdym razem, gdy odwiedzasz witrynę, przeglądarka przesyła te dane z powrotem na serwer."
      )
    ]),
    _c("p", [
      _vm._v(
        "Pliki cookies są zwykle używane w celu rozróżnienia poszczególnych użytkowników, zazwyczaj przechowują zawartość „koszyka” w sklepie internetowym, preferencje użytkownika i nie tylko. Technicznie jest to seria kodów, które przeglądarka zbiera, a następnie wysyła informacje o Twoim zachowaniu z powrotem do odpowiedniego serwera. Pliki cookie zawierają informacje o tym, jak długo przeglądarka powinna je przechowywać (od jednorazowych do kilku lat)."
      )
    ]),
    _c("p", [
      _vm._v(
        "Pliki cookie nie są bezpośrednio powiązane z Twoim nazwiskiem ani adresem e-mail, ale często zawierają dane logowania do systemu. Są wspólne dla jednej instalacji przeglądarki. Cookies nie są w żaden sposób zabezpieczone, w tym zebrane dane."
      )
    ]),
    _c("h3", [_vm._v("Jakich plików cookie używamy?")]),
    _c("p", [
      _vm._v(
        "Używamy plików cookie stron trzecich, w szczególności Google Analytics do analizy ruchu. Te pliki cookie są kontrolowane przez strony trzecie i nie mamy dostępu do odczytywania ani zapisywania tych danych. O warunkach korzystania z Google Analytics możesz przeczytać "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
          }
        },
        [_vm._v("tutaj")]
      ),
      _vm._v(".")
    ]),
    _c("h3", [_vm._v("Co możesz zrobić?")]),
    _c("p", [
      _vm._v(
        "W razie potrzeby możesz odrzucić pliki cookie lub je usunąć. Aby uzyskać instrukcje, jak to zrobić, zobacz sekcję „Pomoc” w przeglądarce internetowej."
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }